import React from 'react';
import ContestPick from "../../../ContestPick/ContestPick";
import useDeviceType from "../../../../hooks/useDeviceType";

import './CreateFromPreSelectedParlayRenderer.style.scss';

import CreateFromPreSelectedParlayHeader from "./CreateFromPreSelectedParlayHeader";
import CreateFromPreSelectedParlayFooter from "./CreateFromPreSelectedParlayFooter";
import {setContestPick} from "../../../../stores/pickX/pickX.thunks";
import {useDispatch} from "react-redux";
import {ContestPickType} from "../../../../constants/PickXEnums";

const CreateFromPreSelectedParlayRenderer = ({parlay, contests, prizeAsset}) => {
    const {isDesktop} = useDeviceType();
    const dispatch = useDispatch();

    const handleContestPickClick = (contestId, pick) => {
        dispatch(setContestPick({
            parlayId: parlay.Id,
            contestId: contestId,
            pick
        }));
    };

    if(!parlay)
        return null;

    return (
        <div className="CreateFromPreSelectedParlayRenderer">
            {!isDesktop && <CreateFromPreSelectedParlayHeader parlay={parlay}
                                                              prizeAsset={prizeAsset} />}
            {contests?.map((contest, index) => (
                <ContestPick
                    key={index}
                    contest={contest}
                    parlay={parlay}
                    onOverClick={() => handleContestPickClick(contest.Id, ContestPickType.Over)}
                    onUnderClick={() => handleContestPickClick(contest.Id, ContestPickType.Under)}
                />
            ))}
            <CreateFromPreSelectedParlayFooter parlay={parlay}
                                               contests={contests}
            />
        </div>
    );

}



export default CreateFromPreSelectedParlayRenderer;